import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import { Link } from 'react-router'
import { includes, last } from 'lodash'
import classNames from 'classnames'
import css from './side-nav.scss'

const SideNav = ({
  activeSlugSet,
  categoryTree,
  maxDepth,
  navCategory,
  renderInMobileNav,
  sidebarTitle,
}) => (
  <div className="hidden-xs">
    <div className="h6 text-bold mbs">{sidebarTitle}</div>
    <hr style={{ maxWidth: 200 }} />
    <ul
      className={classNames('catalog-side-nav list-unstyled', {
        [css.catalogMobileNav]: renderInMobileNav,
      })}
    >
      {navCategory && (
        <CategoryWithChildren
          activeSlugSet={activeSlugSet}
          category={navCategory}
          parentSlugSet={[]}
        />
      )}
      {categoryTree.map((category) => {
        if (category.hidden) return null
        return (
          <CategoryWithChildren
            activeSlugSet={activeSlugSet}
            category={category}
            key={category.urlSlug}
            maxDepth={maxDepth}
            parentSlugSet={[]}
          />
        )
      })}
    </ul>
  </div>
)

SideNav.propTypes = {
  activeSlugSet: PropTypes.arrayOf(PropTypes.string).isRequired,
  categoryTree: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          urlSlug: PropTypes.string,
          path: PropTypes.string,
          image: PropTypes.string,
        })
      ),
      path: PropTypes.string.isRequired,
      urlSlug: PropTypes.string.isRequired,
      image: PropTypes.string,
    })
  ).isRequired,
  renderInMobileNav: PropTypes.bool,
  sidebarTitle: PropTypes.string.isRequired,
}

SideNav.defaultProps = {
  renderInMobileNav: false,
}

const CategoryWithChildren = ({
  activeSlugSet,
  category,
  depth = 1,
  isChild,
  maxDepth,
  parentSlugSet,
}) => {
  const leafCategory =
    !category.children || category.children.length == 0 || depth == maxDepth

  const active = last(activeSlugSet) == category.urlSlug
  const open = !leafCategory && includes(activeSlugSet, category.urlSlug)
  const currentSlugSet = [...parentSlugSet, category.urlSlug]

  return (
    <li
      className={classNames(css.category, { [css.subCategory]: isChild })}
      key={category.title}
    >
      <Link
        className={classNames({ [css.active]: active })}
        to={{ pathname: category.path, state: { slugSet: currentSlugSet } }}
      >
        {category.title}
        {!leafCategory && depth > 1 ? (
          <span className="pls">
            <span
              className={classNames('fa fa-angle-right', css.chevron, {
                [css.activeChevron]: open,
              })}
            />
          </span>
        ) : null}
      </Link>
      {!leafCategory ? (
        <Collapse in={open}>
          <div>
            <ul className={classNames('list-unstyled pbs')}>
              {category.children.map((cat) => {
                if (cat.hidden) return null
                return (
                  <CategoryWithChildren
                    isChild
                    activeSlugSet={activeSlugSet}
                    category={cat}
                    depth={depth + 1}
                    key={cat.urlSlug}
                    maxDepth={maxDepth}
                    parentSlugSet={currentSlugSet}
                  />
                )
              })}
            </ul>
          </div>
        </Collapse>
      ) : null}
    </li>
  )
}

export default SideNav
